import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CLPUserRoleResponse, User, UserResponse } from '../models/user.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class UserService {
    private baseUrl: string; // = "https://localhost:44353/api/officesetup";
    private api: string = "api/User";


    constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
        this.baseUrl = _baseUrl + this.api;
    }

    private handleErrors(errorResponse: HttpErrorResponse) {
        if (errorResponse.error instanceof ErrorEvent) {
            console.error('User Service Client Side Error: ', errorResponse.error.message);
        } else {
            console.error('User Service Server Side Error: ', errorResponse);
        }

        return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
    }

    getUserList(encryptedUser: string): Observable<User[]> {
        return this.httpClient
            .get<User[]>(this.baseUrl, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(), catchError(err => { return this._utilityService.handleErrors(err, null, "", "UserService", "getUserList"); }));
    }

    async getUserById(clpUserId: number, encryptedUser: string): Promise<User | void> {
        const a = await this.httpClient
            .get<User>(`${this.baseUrl}/GetUserById/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "clpUserId - " + clpUserId, encryptedUser, "UserService", "getUserById"); });

        return a;
    }

    getUserByName(userName: number, encryptedUser: string): Observable<User> {
        return this.httpClient
            .get<User>(`${this.baseUrl}/GetUserByUserName/${userName}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp(), catchError(err => { return this._utilityService.handleErrors(err, null, "", "UserService", "getUserByName"); }));
    }

    async getAuthenticateR(encryptedUser: string): Promise<UserResponse | void> {
        const a = await this.httpClient
            .get<UserResponse>(`${this.baseUrl}/AuthenticateR`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "encryptedUser - " + encryptedUser, "UserService", "getAuthenticateR"); });

        return a;
    }

    async getRoleByCLPUser(encryptedUser: string, clpUserId: number): Promise<CLPUserRoleResponse | void> {
        const a = await this.httpClient
            .get<CLPUserRoleResponse>(`${this.baseUrl}/GetRoleByCLPUser/${clpUserId}`, {
                headers: new HttpHeaders({
                    'Authorization': 'Basic ' + encryptedUser
                })
            }).pipe(delayedRetryHttp()).toPromise().catch(err => { this._utilityService.handleErrors(err, null, "encryptedUser - " + encryptedUser, "UserService", "getRoleByCLPUser"); });

        return a;
    }
}
